import $ from '@sparta.global.vendors/jquery';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

/* eslint no-param-reassign: ["error", {"props": true, "ignorePropertyModificationsFor": ["options"]}] */

/**
 * @name        Ah Transport Utility
 * @file        index.js
 * @description This utility is exclusive to the Customer Authentication Widget
 *              for the purpose of initiating Ajax requests and handling the subsequent response.
 *              All request types are POST and CORS support is enabled.
 * @classdesc   This utility is exclusive to the Customer Authentication Widget
 *              for the purpose of initiating Ajax requests and handling the subsequent response.
 *              All request types are POST and CORS support is enabled.
 * @global      Creates a global AhTransportUtility object
 * @author      zkos9ab
 */

const EVENTS = {
  AH_CAW_SYSTEM_ERROR: 'AH_CAW_SYSTEM_ERROR',
  CAW_SYSTEM_ERROR_BAD_REQ: 'AH_CAW_SYSTEM_ERROR_BAD_REQ'
};
let newCsrfToken;
class AhTransportUtility {
  constructor(options) {
    this.options = options || {};
    this.apiCallRecords = {};
  }
  get EVENTS() {
    return EVENTS;
  }
  _serviceCall(options, successCallback, errorCallback, completeCallback) {
    const that = this;
    if (this.apiCallRecords[options.url] && this.apiCallRecords[options.url].inProgress) {
      return false;
    }
    if (options.data) {
      JSON.parse(options.data);
    }
    $(`#${options.loaderInfo}`).show();
    if (options.method && options.method === 'POST') {
      // TODO: Code to set csrf headers
      options.headers = options.headers ? options.headers : {};
      if (options.url && options.url.indexOf('getMobileApp') === -1) {
        options.headers.cawCsrf = newCsrfToken;
      }
      if (options.url && options.url.indexOf('verifyAuthentication') === -1) {
        options.headers['Accept-language'] = $('html').attr('lang');
      }
    }
    $.support.cors = true;
    this.apiCallRecords[options.url] = {
      inProgress: true
    };
    $.ajax({
      headers: options.headers,
      url: options.url,
      xhrFields: {
        withCredentials: true
      },
      cache: false,
      data: options.data,
      method: options.method,
      contentType: options.contentType ? options.contentType : 'application/json',
      dataType: options.dataType,
      error(jqXHR, exception, errorThrown) {
        /** Event is used to validate all the status in form of error scenarios received from backend and will make a generic error display with the provided error Code */
        spartaEventsUtility.pub(that.EVENTS.CAW_SYSTEM_ERROR_BAD_REQ, {
          url: options.url,
          jqXHR
        });
        if (errorCallback) {
          errorCallback(jqXHR, exception, errorThrown);
        }
      },
      success: (jsonMsg, textStatus) => {
        let response = {
          result: '',
          responseData: '',
          textStatus: ''
        };
        if (jsonMsg) {
          response = {
            result: 'success',
            responseData: jsonMsg,
            textStatus
          };
        }
        if (successCallback) {
          successCallback(response);
        }
      },
      complete: jqXHR => {
        this.apiCallRecords[options.url] = {
          inProgress: false
        };
        $(`#${options.loaderInfo}`).hide();
        if (jqXHR) {
          newCsrfToken = jqXHR.getResponseHeader('cawCsrf');
        }
        if (completeCallback) {
          completeCallback(jqXHR);
        }
      }
    });
  }
}

/**
 * @const ServiceCallUtility
 * @description single isntance of ServiceCallUtility used to expose this utility
 */
const ahTransportUtility = new AhTransportUtility();

export { ahTransportUtility as default };
